import { SerializableError } from "../utils/serializable-error.js";
class SubscriptionError extends SerializableError {
  constructor(message, details) {
    super(message);
    this.details = details.details;
  }
}
export {
  SubscriptionError
};
//# sourceMappingURL=types.js.map
